export default "__VITE_ASSET__D7q8nXLp__"